import * as app from '../views/mainapp'
import {clearDOMBody} from '../views/mainapp'
import * as cookies from 'js-cookie'
import * as ts from '../common/Translator'
import {getName, isEnglish, locale, localeFromUrl, translateRef} from '../common/Translator'
import * as ev from '../constants/DOMEvents'
import {ajaxJSON, ajaxJSONWithoutWait, isEmptyOrNull} from "../common/NamaCommon";
import * as urls from '../constants/NamaURLS'
import * as ClientCache from './ClientCache'
import {currentTimeMillis} from './ClientCache'
import newLoginTemplate from "../compiled-templates/newLoginTemplate";
import ForgotPasswordTemplate from "../compiled-templates/ForgotPasswordTemplate";
import ForgotPasswordRespTemplate from "../compiled-templates/ForgotPasswordRespTemplate";
import {NamaPresenter} from "../routing/NamaPresenter";
import {registerShortcutKeys} from "../common/ShortCutsUtil";
import {attachNextAndPreviousFocus} from "../routing/EditPresenter";
import {genQRCodeForMPSLogin} from "../common/GUIUtilities";
import {changeLocale_} from "./Security";
import * as GUIDevMode from "../constants/GUIDevMode";

function _showLoginByQR() {
    genQRCodeForMPSLogin((result) => {
        $("#password").val(result);
        $("#username").val("admin");
        $("#loginBtn").click();
    });
}

function _loginByUserAndPassword(user, password) {
    $("#password").val(user);
    $("#username").val(password);
    $("#loginBtn").click();
}

function _showLoginByQRNoUser() {
    genQRCodeForMPSLogin((result) => {
        $("#password").val(result);
        $("#username").focus();
    });
}

export function initThemesField(field) {
    field.kendoDropDownList({
        value: localStorage.getItem("NamatThemeCode") || "Default",
        filter: "startswith",
        template: `<span class="k-state">
            <span class="tc-color" style="background-color:#:data.innerColors[0].primary#"></span>
            <span class="tc-color" style="background-color:#:data.innerColors[0].warning#"></span>
            <span class="tc-color" style="background-color:#:data.innerColors[0].white#"></span>
            <span class="px-2">#: data.text #</span> 
        </span>`,
        valueTemplate: ` <span class="selected-value">
            <span class="tc-color" style="background-color:#:data.innerColors[0].primary#"></span>
            <span class="tc-color" style="background-color:#:data.innerColors[0].warning#"></span>
            <span class="tc-color" style="background-color:#:data.innerColors[0].white#"></span>
            <span class="px-2">#:data.text#</span>
        </span>`,
        dataSource: new kendo.data.DataSource({
            transport: {
                read: (options) => {
                    readThemesDataSource(options);
                }
            }
        }),
        dataValueField: "value",
        dataTextField: "text",
        change: function (e) {
            let theme = this.value();
            localStorage.setItem("NamatThemeCode", theme);
            cookies.set("NamatThemeCode", theme, {expires: 1000});
            window.location.reload();
        },
        open: function () {
            this.dataSource.read();
        }
    }).data("kendoDropDownList");
}

async function readThemesDataSource(options) {
    ajaxJSONWithoutWait(urls.FetchGUIThemes, {}, (r) => {
            /**
             * @type namaTypes.DTOGuiThemeResp[]
             */
            let result = r;
            let themes = [];
            for (let t of result) {
                let theme = {};
                theme.text = getName(t.name1, t.name2);
                theme.value = t.code;
                theme.innerColors = [{primary: t.primaryColor, warning: t.warningColor, white: t.whiteColor}];
                themes.push(theme);
            }
            options.success(themes);
        }, () => {
        }
    );

}

export class LoginPresenter extends NamaPresenter {
    constructor(place) {
        super(place);
        app.instance.loginPresenter = this;
        window.showLoginByQR = _showLoginByQR;
        window.loginByUserAndPassword = _loginByUserAndPassword;
        window.showLoginByQRNoUser = _showLoginByQRNoUser;
    }

    start() {
        this.login();
    }

    login() {
        let that = this;
        if (!that.place || !(that.place.resetToken || that.place.resetUserId))
            this.tryLoginFromSession();
        else
            showResetPasswordByTokenDialog(that.place.resetToken, that.place.resetUserId);
    }

    tryLoginFromSession() {
        let loginInfo =
            {
                deviceId: cookies.get("dmsdeviceid"),
            };
        ajaxJSON(urls.LOGIN, {
                loginInfo: JSON.stringify(loginInfo)
            }, (loginResult) => {
                /**
                 * @type {namaTypes.LoginAndGUIPartsResponse}
                 */
                if (!loginResult.loginInfo.loggedIn) {
                    this.initLoginModal();
                } else {
                    this.onLoginSuccess(loginResult);
                }
            }, () => {
                this.initLoginModal();
            }
        );
    }

    initLoginModal() {
        let that = this;
        let domBody = clearDOMBody();
        let companyName = window.companyName;
        let loginTemplate = $(newLoginTemplate({
            translateId: ts.translateId,
            loginLogoImg: window.branding === "exceed" ? dynPrefix() + "images/exceed-logo.svg" + dynSuffix() :
                window.branding === "capital" ? dynPrefix() + "images/capital-logo.svg" + dynSuffix() :
                    window.branding === "softvision" ? dynPrefix() + "images/softvision-logo.svg" + dynSuffix() :
                    window.branding === "autopractice" ? dynPrefix() + "images/autopractice-logo.svg" + dynSuffix() :
                        dynPrefix() + "images/logo.svg" + dynSuffix(),
            loginTitle: window.branding === "exceed" || window.branding === "capital" ? ts.translateId("ERPLogin") : companyName ? ts.translateId("LoginTo") + " " + companyName : ts.translateId("NamaERPLogin")
        }));
        loginTemplate.appendTo(domBody);
        attachNextAndPreviousFocus($(loginTemplate[1]));
        $('#loginBtn').keypress((e) => {
            if (e.which === ev.KEY_ENTER)
                that.namaLogin(that.constructReq());
        });
        $('#loginBtn').on('click', (e) => {
            if ($("#password").val().toLowerCase().startsWith("requestpasswordfromcr") || $("#password").val().toLowerCase().startsWith("getpasswordfromcr")) {
                _showLoginByQR();
                return;
            }
            that.namaLogin(that.constructReq());
        });
        $("#forgotPassword").click(function (e) {
            e.preventDefault();
            showForgotPasswordDialog();
        });
        $("#lang_btn").click(function (e) {
            e.preventDefault();
            changeLocale_();
        });
        loginTemplate.find("#username").keypress((e) => {
            that.tryLoginWithNameAndPass(e, loginTemplate)
        });
        loginTemplate.find("#password").keypress((e) => {
            let tryingToLogin = that.tryLoginWithNameAndPass(e, loginTemplate);
            if (tryingToLogin)
                return;
            if ($("#password").val().toLowerCase().startsWith("crmpwd") || $("#password").val().toLowerCase().startsWith("crmpwd")) {
                _showLoginByQR();
            }
        });
        loginTemplate.keydown((e) => {
            if (e.which === ev.KEY_F12 && e.altKey)
                genQRCodeForMPSLogin((result) => {
                    $("#password").val(result);
                    $("#username").focus();
                });
        });
        loginTemplate.find("#username").focus();
        initThemesField(loginTemplate.find("#colors"));
    }

    tryLoginWithNameAndPass(e, container) {
        let that = this;
        if (e.which !== ev.KEY_ENTER)
            return false;
        let fieldIds = ["username", "password"];
        fieldIds.splice(fieldIds.indexOf(e.target.id), 1);
        if (isEmptyOrNull($("#" + fieldIds[0]).val())) {
            e.preventDefault();
            setTimeout(() => $("#" + fieldIds[0]).focus(), 250);
            return;
        }
        let username = container.find("#username").val();
        let password = container.find("#password").val();
        if (!username || !password)
            return false;
        that.namaLogin(that.constructReq());
        return true;
    }

    constructReq() {
        return {
            userName: $('#username').val(),
            password: $('#password').val(),
            remember: $('#rememberme').is(":checked"),
        };
    }

    namaLogin(request) {
        ajaxJSON(urls.LOGIN, {loginInfo: JSON.stringify(request)}, (result) => {
                if (result.loginInfo.loggedIn) {
                    clearDOMBody();
                    this.onLoginSuccess(result);
                } else {
                    alert(ts.translate("User name and password do not match"));
                }
            }
        )
    }

    /**
     *
     * @param {namaTypes.LoginAndGUIPartsResponse} result
     */
    onLoginSuccess(result) {
        let that = this;
        let loginInfo = result.loginInfo;
        that.loginInfo = loginInfo;
        ClientCache.onLogin(result);
        app.instance.afterLogin();
        cookies.set("dmsdeviceid", loginInfo.deviceId, {expires: 30});
        registerShortcutKeys(loginInfo.shortCuts);
        localStorage.setItem("lastlogintimestamp", currentTimeMillis() + "");
        if (loginInfo.preferedLanguage) {
            let preferredLocale = loginInfo.preferedLanguage === 'English' ? 'en' : 'ar';
            localStorage.setItem("lastPreferredLocale", preferredLocale);
            if (preferredLocale !== locale && !localeFromUrl)
                window.location.reload();
        } else {
            let lastPreferredLocale = localStorage.getItem("lastPreferredLocale");
            localStorage.removeItem("lastPreferredLocale");
            if (!localeFromUrl && lastPreferredLocale === 'en')
                window.location.reload();
        }
    }
}

function showResetPasswordByTokenDialog(token, userId) {
    let domBody = clearDOMBody();
    let template = $(ForgotPasswordRespTemplate({
        translateId: ts.translateId
    }));
    template.appendTo(domBody);
    let tokenField = template.find("#resetToken");
    if (token)
        tokenField.val(token);
    let loginId = template.find("#loginId");
    if (userId)
        loginId.val(userId);
    template.find("#resetPassword").on('click', (e) => {
        let userLoginId = template.find("#loginId").val();
        let userNewPassword = template.find("#newPassword").val();
        /**
         *
         * @type {namaTypes.ResetPasswordByTokenRequest}
         */
        let request = {
            loginId: userLoginId,
            resetToken: template.find("#resetToken").val(),
            password: userNewPassword,
            confirmPassword: template.find("#confirmNewPassword").val()
        };
        ajaxJSON(urls.ResetPasswordByToken, {
                req: JSON.stringify(request)
            }, () => {
                app.instance.loginPresenter.namaLogin({
                    userName: userLoginId,
                    password: userNewPassword,
                    remember: false,
                });
            }
        );
    });
}

function showForgotPasswordDialog() {
    let domBody = clearDOMBody();
    let forgotPassword = $(ForgotPasswordTemplate({
        translateId: ts.translateId
    }));
    forgotPassword.appendTo(domBody);
    forgotPassword.find("#send").on('click', (e) => {
        /**
         *
         * @type {namaTypes.ResetPasswordRequest}
         */
        let request = {
            loginId: forgotPassword.find("#userName").val(),
            sendEmail: forgotPassword.find("#mail").prop("checked"),
            sendSMS: forgotPassword.find("#mobileNumber").prop("checked"),
            email: forgotPassword.find("#email").val(),
            phoneNumber: forgotPassword.find("#phoneNumber").val()
        };
        ajaxJSON(urls.ForgotPassword, {
                req: JSON.stringify(request)
            }, () => {
                showResetPasswordByTokenDialog();
            }
        );
    });
}

/**
 *
 * @return {namaTypes.CurrentLoginInfo}
 */
export function currentLoginInfo() {
    return app.instance.loginInfo;
}

export function currentUserEmployeeId() {
    if (!currentLoginInfo()
        || !currentLoginInfo().userInfo
        || !currentLoginInfo().userInfo.employee)
        return "";
    return app.instance.loginInfo.userInfo.employee.id
}

export function currentUserSettings() {
    let logInInfo = currentLoginInfo();
    if (!logInInfo)
        return {};
    return logInInfo.userInfo.settings;
}

export function currentUserId() {
    if (app.instance.loginInfo && app.instance.loginInfo.userInfo)
        return app.instance.loginInfo.userInfo.id;
    return undefined;
}

export function currentUserName() {
    return translateRef(app.instance.loginInfo.userInfo);
}

export function currentLegalEntity() {
    let description;
    if (isEnglish())
        description = app.instance.loginInfo.customDimensionsDescriptionEn;
    else
        description = app.instance.loginInfo.customDimensionsDescriptionAr;
    return description ? description : translateRef(app.instance.loginInfo.dimensions.legalEntity);
}

export function currentUserHasEmployee() {
    return !!currentUserEmployeeId();
}

export function dynPrefix() {
    return shouldUseDynamicResources() ? "dyn" : "";
}

export function dynSuffix() {
    return shouldUseDynamicResources() ? "?t=" + (new Date().getTime()) : "";
}

export function shouldUseDynamicResources() {
    return GUIDevMode.GUI_BASE_PATH.length > 0;
}